import { useState, useContext, useEffect } from "react";
import { useNavigate, Routes, Route, Navigate } from "react-router-dom";
import { ThemeContext } from "../../App";
import Provas from "./Provas";
import Equipas from "./Equipas";
import ProvaHistory from "./ProvaHistory";
import LeaderboardController from "./LeaderboardController";
import Sidebar from "./Sidebar";
import Accounts from "./Accounts";
import {
    AppBar,
    Box,
    CssBaseline,
    Drawer,
    IconButton,
    Toolbar,
    Typography,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Console from "./Console";
import DatabaseManager from "./DatabaseManager";

const drawerWidth = 240;

export default function Admin() {
    const navigate = useNavigate();
    const { isDarkMode } = useContext(ThemeContext);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [open, setOpen] = useState(false);

    useEffect(() => {
        (async () => {
            const res = await fetch("/auth/verify", { credentials: "include" });
            if (!res.ok) navigate("/login");
        })();
    }, [navigate]);

    const toggleDrawer = () => {
        setOpen(!open);
    };

    const handleMobileDrawerClose = () => {
        if (isMobile) {
            setOpen(false);
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                minHeight: "100vh",
                backgroundColor: isDarkMode ? "#121212" : "#f5f5f5",
            }}>
            <CssBaseline />
            <AppBar
                position="fixed"
                sx={{
                    backgroundColor: isDarkMode ? "#1e1e1e" : "#ffffff",
                    color: isDarkMode ? "#ffffff" : "#212529",
                    boxShadow: 1,
                    width: { md: `calc(100% - ${drawerWidth}px)` },
                    ml: { md: `${drawerWidth}px` },
                }}>
                <Toolbar>
                    {isMobile && (
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={toggleDrawer}
                            sx={{ mr: 2 }}>
                            <MenuIcon />
                        </IconButton>
                    )}
                    <Typography variant="h6" noWrap>
                        Dashboard
                    </Typography>
                </Toolbar>
            </AppBar>

            <Box
                component="nav"
                sx={{ width: { md: drawerWidth }, flexShrink: 0 }}>
                <Drawer
                    variant={isMobile ? "temporary" : "permanent"}
                    open={isMobile ? open : true}
                    onClose={toggleDrawer}
                    ModalProps={{ keepMounted: true }}
                    sx={{
                        "& .MuiDrawer-paper": {
                            width: drawerWidth,
                            boxSizing: "border-box",
                        },
                    }}>
                    <Sidebar onMobileClose={handleMobileDrawerClose} />
                </Drawer>
            </Box>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 3,
                    mt: 8,
                    width: { md: `calc(100% - ${drawerWidth}px)` },
                }}>
                <Routes>
                    <Route index element={<Navigate to="provas" replace />} />
                    <Route path="provas/*" element={<Provas />} />
                    <Route path="equipas/*" element={<Equipas />} />
                    <Route path="historico/*" element={<ProvaHistory />} />
                    <Route
                        path="leaderboard/*"
                        element={<LeaderboardController />}
                    />
                    <Route path="console/*" element={<Console />} />
                    <Route path="accounts/*" element={<Accounts />} />
                    <Route path="database/*" element={<DatabaseManager />} />
                </Routes>
            </Box>
        </Box>
    );
}
